import { defineComponent, computed, ref, watch, onMounted } from '@vue/composition-api';
import { isSafari, isMobileSafari } from '@superbet-group/web.lib.vue-utilities';
import __vue_component__ from './SdsGlobalHeaderIconMobile.vue.js';
import __vue_component__$1 from '../SdsLogo/SdsLogo.vue.js';

var script = defineComponent({
    name: 'SdsGlobalHeaderMobile',
    props: {
        headerActionItems: {
            type: Array,
            required: false,
            default: function () { return []; },
        },
        title: {
            type: String,
            required: false,
            default: undefined,
        },
        isHome: {
            type: Boolean,
            required: false,
            default: false,
        },
        isFeatured: {
            type: Boolean,
            required: false,
            default: false,
        },
        isContracted: {
            type: Boolean,
            required: false,
            default: false,
        },
        brand: {
            type: String,
            required: false,
            default: undefined,
        },
        logoDestination: {
            type: Object,
            required: false,
            default: undefined,
        }
    },
    emits: [
        'click:back',
        'click:rightSideIcon',
    ],
    setup: function (props, _a) {
        var slots = _a.slots;
        var hasLeftSideSlot = computed(function () { return !!slots['leftSide']; });
        var hasBottomSlot = computed(function () { return !!slots['bottom']; });
        var isHeaderContracted = ref(props.isContracted || props.isHome || (!props.title && !hasBottomSlot.value));
        watch(function () { return [props.isContracted, props.isHome, props.title, hasBottomSlot.value]; }, function () {
            isHeaderContracted.value = props.isContracted || props.isHome || (!props.title && !hasBottomSlot.value);
        });
        onMounted(function () {
            window.addEventListener('scroll', function () {
                isHeaderContracted.value = document.documentElement.scrollTop > 50
                    || props.isContracted
                    || props.isHome
                    || (!props.title && !hasBottomSlot.value);
            }, { passive: true });
        });
        var showLogo = computed(function () { return !!props.brand && props.isHome; });
        var showBottomSlot = computed(function () { return !isHeaderContracted.value && !props.isHome && (hasBottomSlot.value || props.title); });
        return {
            showBottomSlot: showBottomSlot,
            showLogo: showLogo,
            hasLeftSideSlot: hasLeftSideSlot,
            isHeaderContracted: isHeaderContracted,
            isSafari: isSafari,
            isMobileSafari: isMobileSafari,
        };
    },
    components: {
        SdsGlobalHeaderIconMobile: __vue_component__,
        SdsLogo: __vue_component__$1,
    },
});

export default script;
